@if (sendingStatus) {
<ngb-alert insert-alert-icon [dismissible]="isDismissible" type="info" data-test="alert-loader">
  <div class="d-flex align-items-center">
    <strong>{{ message }}</strong>
    <div class="spinner-border spinner-border-sm ms-auto" role="status" aria-hidden="true"></div>
  </div>
</ngb-alert>
}
